import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-friendly-society',
  templateUrl: './friendly-society.component.html',
  styleUrls: ['./friendly-society.component.css'],
})
export class FriendlySocietyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
